import React from "react"
import { Container } from "reactstrap"
import { FormattedMessage, useIntl } from "gatsby-plugin-intl"
import routes, { getLocalizedRoute } from "../routes"

let SubFooter = (props: { title?: string }) => {
  const intl = useIntl()
  return (
    <div className=" subfooter">
      <Container
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
        // className="pb-3"
      >
        <div style={{ flexGrow: 3 }} />
        <span className="text-secondary small">
          {"Copyright (c) "}
          {new Date().getFullYear()}
          {" Wegener Center/University of Graz"}
        </span>
        <div style={{ flexGrow: 8 }} />
        <a
          className="text-secondary small"
          href={getLocalizedRoute(routes.contact, intl)}
        >
          <FormattedMessage id={"footer.contact"} />
        </a>
        <div style={{ flexGrow: 1 }} />
        <a
          className="text-secondary small"
          href={getLocalizedRoute(routes.imprint, intl)}
        >
          <FormattedMessage id={"footer.imprint"} />
        </a>
        <div style={{ flexGrow: 1 }} />
        <a
          className="text-secondary small"
          href={getLocalizedRoute(routes.dataProtectionRegulation, intl)}
        >
          <FormattedMessage id={"footer.privacyPolicy"} />
        </a>
        <div style={{ flexGrow: 3 }} />
      </Container>
    </div>
  )
}

export default SubFooter
